import React, { useEffect, useState } from "react";
import "./App.css";
import LoginPage from "./components/LoginPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TenantsPage from "./components/tenants/TenantsPage";
import { ThemeProvider } from "./theme/theme";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./services/authConfig";
import configureAxios from "./3rd-parties/axios";
import { clearReturnUrl, getReturnUrl } from "./services/localStorageService";

function App() {
  configureAxios(msalInstance)
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    msalInstance.handleRedirectPromise().then((response) => {
      if (response) {
        msalInstance.setActiveAccount(response.account);
        const redirectUrl = getReturnUrl();        
        if (redirectUrl) {
          clearReturnUrl();
          window.location.replace(redirectUrl);
        }
      } else {
        const currentAccounts = msalInstance.getAllAccounts();
        if (currentAccounts.length === 1) {
          msalInstance.setActiveAccount(currentAccounts[0]);
        }
      }
    }).catch(error => {
      console.error("MSAL redirect error:", error);
    }).finally(() => {
      setIsReady(true);
    });
  }, []);
if (!isReady) return <div/>;

  return (
    <ThemeProvider>
      <MsalProvider instance={msalInstance}>
        <Router>
          <Routes>
            <Route path="/" element={<TenantsPage />} />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </Router>
      </MsalProvider>
    </ThemeProvider>
  );
}

export default App;
